import type { FC } from 'react';

import type { Address } from '@core/types/api/Address/Address';

import type { PinType } from '../MapPins/mapPins';
import { SlabMapConfigWrapper } from '../SlabMap/SlabMapConfigWrapper';
import { AddressField } from './AddressField';
import { MapField } from './MapField';

interface AddressMapFieldProps {
  name: string;
  isCityRequired?: boolean;
  isRequired?: boolean;
  onAddressChange?(address: Address): void;
  pinTypes?: PinType[];
}

export const AddressMapField: FC<AddressMapFieldProps> = ({
  name,
  isCityRequired = false,
  isRequired = false,
  onAddressChange,
  pinTypes,
}) => {
  return (
    <SlabMapConfigWrapper>
      <AddressField
        onAddressChange={onAddressChange}
        name={name}
        isCityRequired={isCityRequired}
        isRequired={isRequired}
      />
      <MapField onAddressChange={onAddressChange} name={name} pinTypes={pinTypes} />
    </SlabMapConfigWrapper>
  );
};
